import React, {useEffect, useState} from "react";

import './UnreportedSystemsTable.scss'
import {useRecoilValue} from "recoil";
import {grpcReportServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarMenu,
  TableToolbarSearch
} from "@carbon/react";
import PropTypes from "prop-types";
import {Renew} from "@carbon/react/icons";

const UnreportedSystemsTable = (props) => {
  const headers = [{
    key: 'name', header: 'Nome'
  }, {
    key: 'systemEmail', header: 'Email sistema'
  }, {
    key: 'serviceH24', header: 'H24'
  }, {
    key: 'warrantyExpiration', header: 'Scadenza garanzia'
  }, {
    key: 'systemType', header: 'Tipo sistema'
  }];

  const date = props.DateRef
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [rows, setRows] = useState([])
  const [pageSize, setPageSize] = useState(10)
  const [firstRowIndex, setFirstRowIndex] = useState(0)
  const reportsService = useRecoilValue(grpcReportServiceSelector)

  const enrichCustomersWithIds = (customers) => {
    return customers.map(c => {
      c.id = c.code;
      return c
    })
  }

  const getUnreportedSystemsTableData = (date) => {
    const req = new proto.api.ListUnreportedSystemsRequest();
    req.setFromDate(date + " 00:00:00")
    req.setToDate(date + " 23:59:59")
    setLoading(true)
    reportsService.listUnreportedSystems(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setRows(enrichCustomersWithIds(resp.toObject().systemsList))
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    getUnreportedSystemsTableData(date)
  }, [date]);

  if (loading) {
    return (
      <DataTableSkeleton
        columnCount={headers.length + 1}
        rowCount={5}
        headers={headers}
      />
    )
  }

  if (error) {
    return (<div>
      <span>ERROR!</span>
    </div>)
  }

  const processChildren = (cell) => {
    let value = cell.value
    switch (cell.info.header) {
      case "serviceH24": {
        value = cell.value ? "Si" : "No"
        break
      }
      case "systemType": {
        value = cell.value.length > 0 ? cell.value : "Rileva in automatico"
        break
      }
    }
    return (<>
      {value}
    </>)
  }

  const handlePaginationChange = (page, newPageSize) => {
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
    setFirstRowIndex(newPageSize * (page - 1));
  }

  return (
    <DataTable
      rows={rows}
      headers={headers}
      isSortable
      overflowMenuOnHover={false}
      render={({
                 rows,
                 headers,
                 getHeaderProps,
                 getRowProps,
                 getToolbarProps,
                 onInputChange,
                 getTableProps,
                 getTableContainerProps,
               }) => {
        return (
          <TableContainer title="Lista sistemi offline"
                          description="Sistemi che non hanno inviato i report (segnali vita)" {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()} >
              <TableToolbarContent>
                <TableToolbarSearch
                  persistent
                  placeholder="Filtra i sistemi offline.."
                  onChange={onInputChange}/>
                <TableToolbarMenu
                  renderIcon={Renew}
                  onClick={() => getUnreportedSystemsTableData(date)}
                  light
                  iconDescription="Aggiorna" />
              </TableToolbarContent>
            </TableToolbar>
            <Pagination
              totalItems={rows.length}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={pageSize}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.slice(firstRowIndex, firstRowIndex + pageSize).map((row) => (
                  <TableRow key={row.id} {...getRowProps({row})}>
                    {row.cells.map((cell) => (<TableCell key={cell.id}>
                      {processChildren(cell)}
                    </TableCell>))}
                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>);
      }}
    />
  )
}

UnreportedSystemsTable.propTypes = {
  DateRef: PropTypes.string.isRequired,
}

export default UnreportedSystemsTable
